export interface IUser {
  lockoutEnd: string
  twoFactorEnabled: boolean
  phoneNumberConfirmed: boolean
  phoneNumber: string
  concurrencyStamp: string
  securityStamp: string
  password: string
  passwordHash: string
  emailConfirmed: boolean
  normalizedEmail: string
  email: string
  normalizedUserName: string
  userName: string
  id: string
  lockoutEnabled: boolean
  accessFailedCount: number
  createdDateTime: string
  updatedDateTime: string
  createdBy: string
  lastUpdatedBy: string
  name: string
  emailValidationCode: number
  emailValidationCodeDate: string
  emailConfirmationDate: string
  phoneNumberValidationCode: string
  phoneNumberValidationCodeDate: string
  phoneNumberConfirmationDate: string
  phoneCountryIndicator: number
  country: string
  timeZone: string
  dateTimeFormat: string
  language: number
  userStatus: number
  inactiveDateTime: string
  msisdn: string
}

export enum LanguagemEnum {
  ENGLISH = 1,
  PORTUGUESE = 2,
}

export enum BusinessProfileEnum {
  COMPANY = 1,
  AGENCY = 2,
  INDIVIDUAL_FREELANCER = 3,
  UNDEFINED = 4,
}

export enum OrganizationTypeEnum {
  Sendit = 1,
  Client,
}

export enum BusinessAreaEnum {
  Unknown = 1,
  PublicAdministration = 2,
  MktPubAgency = 3,
  ArtEntreteimnet = 4,
  BankInsurance = 5,
  Sports = 6,
  Ecommerce = 7,
  Education = 8,
  Events = 9,
  LegalFunctions = 10,
  HotelsRestaurants = 11,
  HumanResources = 12,
  Retail = 13,
  Healthy = 14,
  FinancialTaxServices = 15,
  InformationTechnologies = 16,
  Telecommunications = 17,
  Tourism = 18,
  Other = 19,
}

export enum OrganizationStatusEnum {
  Inactive = 1,
  Active = 2,
  Deleted = 3,
  Pending_Plan_Setup = 4,
}

export enum InvoiceTypeEnum {
  INDEPENDENT = 1,
  AGGREGATE,
}

export enum OrganizationBalanceConfigTypeEnum {
  NO_OWN_BALANCE = 1,
  OWN_BALANCE_DEPENDENT,
  OWN_BALANCE_INDEPENDENT,
}

export interface IBillingInfo {
  id: number
  name: string
  taxIdentificationNumber: string
  address: string
  postalCode: string
  city: string
  country: string
  phoneCountryIndicator?: number
  phoneNumber: string
  email: string
  countryId: string
  detailCountry: string
  isFinalConsumer: boolean
}

export enum ContactDetailsTypeEnum {
  Main = 1,
  Financial = 2,
  IT = 3,
}

export interface IOrganizationContactDetails {
  organizationId: number
  contactDetailsType: ContactDetailsTypeEnum
  name: string
  email: string
  phoneCountryIndicator: number
  phoneNumber: string
}

export interface IOrganization {
  id: string
  organizationId: string
  companyName: string
  organizationType: OrganizationTypeEnum
  businessArea?: BusinessAreaEnum
  organizationStatus: OrganizationStatusEnum
  businessProfile: BusinessProfileEnum
  parentOrganizationId?: number
  email: string
  phoneCountryIndicator?: number
  phoneNumber: string
  employees?: number
  nodePath: string
  inactiveDateTime?: string
  deletedDateTime?: string
  isNew: boolean
  createdByUserId: string
  createdDateTime: string
  updatedDateTime: string
  createdBy: string
  lastUpdatedBy: string
  invoiceType: InvoiceTypeEnum
  isUsingDefaultInvoiceInfo: boolean
  organizationBalanceConfigType: OrganizationBalanceConfigTypeEnum
  isUsingParentBillingInfo: boolean
  billingInfo: IBillingInfo
  organizationContactDetails: IOrganizationContactDetails[]
  hasWhiteLabelCustomization: boolean
}

export enum PermissionTypeEnum {
  Organization_View = 1,
  Organization_Search = 2,
  Organization_Create = 3,
  Organization_AddUser = 4,
  Organization_Status_Read = 5,
  Organization_Order = 6,
  Organization_Edit = 7,
  Organization_Delete = 8,
  Organization_Select = 9,
  Organization_SendInvite = 10,
  Organization_DeleteInvite = 11,
  Organization_Edit_Parent = 12,
  Audience_Read = 1000,
  Audience_Write = 1001,
  Audience_Dashboard_Read = 1002,
  Audience_Dashboard_Write = 1003,
  Audience_Create = 1004,
  Audience_Search_Read = 1005,
  Audience_Search_Write = 1006,
  Audience_ImportRecipients = 1007,
  Audience_ImportHistory_Read = 1008,
  Audience_ExportAudience = 1009,
  Audience_CustomFields_Write = 1010,
  Audience_Delete = 1011,
  Audience_Select = 1012,
  Audience_Status_Read = 1013,
  Audience_Order = 1014,
  Audience_Edit = 1015,
  Audience_DeleteRecipients = 1016,
  Audience_Insights_Read = 1017,
  Audience_FileUpload = 1018,
  Audience_ManualUpload = 1019,
  Audience_AdditionalUpload = 1020,
  Audience_Segment_Create = 1021,
  Audience_Segment_Export = 1022,
  Audience_Segment_Edit = 1023,
  Audience_Segment_Delete = 1024,
  Audience_Segment_Select = 1025,
  Audience_Segment_Status_Read = 1026,
  Audience_Segment_Order = 1027,
  Audience_Channel_Email = 1028,
  Audience_Channel_Sms = 1029,
  Audience_Channel_Push_Notification = 1030,
  Audience_Channel_Voice = 1031,
  Notification_View = 2000,
  Notification_Delete = 2001,
  Notification_ClearAll = 2002,
  Campaign_Send = 2003,
  Settings_Profile_Read = 3000,
  Settings_Organization_Users_Read = 3001,
  Settings_Organization_Users_Write = 3002,
  Settings_Senders_Read = 3003,
  Settings_Senders_Write = 3004,
  Settings_Integrations_Read = 3005,
  Settings_Integrations_Write = 3006,
  Settings_PrivacyCookies_Read = 3007,
  Sender_Create = 4000,
  Sender_Order = 4001,
  Sender_Status = 4002,
  Sender_Select = 4003,
  Sender_Delete = 4004,
  Sender_AddUser = 4005,
  Sender_DownloadDocument = 4006,
  Sender_UserList = 4007,
  Sender_ValidateRequest = 4008,
  Sender_RemoveUser = 4009,
  Sender_Sendit_Domain_Reply = 4010,
  Sender_Sendit_Sms_Approve_Or_Refuse = 4011,
  Sender_SenderList = 4012,
  Campaign_Write = 5001,
  Campaign_Read = 5002,
  Template_Write = 6001,
  Template_Read = 6002,
  Balance_Read_Balance = 7000,
  Balance_Write_Balance = 7001,
  Balance_Plan_Buy = 7002,
  Balance_Addon_Buy = 7003,
  Balance_Billing_Read = 7004,
  Balance_Billing_Write = 7005,
  Balance_Billing_Overview = 7006,
  Balance_Billing_Invoices = 7007,
  Balance_Billing_Consumption_Report = 7008,
}

export interface IPermission {
  type: PermissionTypeEnum
  value: string
}

export interface PrivateDataAccessRequest {
  id: string
  userId: string
  targetOrganizationId: string
  status: PrivateDataAccessRequestStatusEnum
  statusUpdateDateTime: string
  answeredByUserId?: string
  expirationDateTime?: string
  hasBeenAnswered: boolean
  originUserName: string
  originEmail: string
}

export enum PrivateDataAccessRequestStatusEnum {
  PENDING = 1,
  APPROVED,
  REJECTED,
}

export interface SalesManager {
  name: string
}
